// extracted by mini-css-extract-plugin
export default {"alert":"src-signer-app-signer-decline-modal-signer-decline-modal-module__alert--1nC4o"};